var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "lang-switcher-view" } }, [
    _c(
      "span",
      {
        staticClass: "first-span switch-button",
        class: { active: _vm.$i18n.locale === "cs" },
        on: {
          click: function ($event) {
            return _vm.changeLang("cs")
          },
        },
      },
      [_vm._v("CZ")]
    ),
    _c(
      "span",
      {
        staticClass: "second-span switch-button",
        class: { active: _vm.$i18n.locale === "en" },
        on: {
          click: function ($event) {
            return _vm.changeLang("en")
          },
        },
      },
      [_vm._v("EN")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }